import axios from 'axios';

import { httpClient } from '@/core/api/http-client';

import type { SignedUrlResponse } from './providers.types';

export const providersService = {
  /**
   * Requests a GCS signed URL for a contract file upload.
   * Endpoint: GET /admin/providers/signed_url?file_name=...&content_type=...
   *
   * NOTE: This endpoint does not exist yet in the backend. Once implemented,
   * the frontend uploads the file directly to GCS using the returned
   * `upload_url` — the binary never passes through the API.
   */
  getSignedUrl: async (file_name: string, content_type: string): Promise<SignedUrlResponse> => {
    const response = await httpClient.get<SignedUrlResponse>('/admin/providers/signed_url', {
      params: { file_name, content_type },
    });
    return response.data;
  },

  /**
   * Uploads a file directly to GCS using a pre-signed PUT URL.
   * Uses a plain axios instance — NOT httpClient — so the Auth0 Bearer
   * token is not sent to GCS (GCS rejects unknown Authorization headers).
   */
  uploadToGcs: async (signed_url: string, file: File): Promise<void> => {
    await axios.put(signed_url, file, {
      headers: { 'Content-Type': file.type },
    });
  },
};
